import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-cancel-contract',
  templateUrl: './cancel-contract.component.html',
  styleUrls: ['./cancel-contract.component.scss']
})
export class CancelContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  cancelContract(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.contractData.active = 0;
    delete this.contractData["contractInstallments"];
    this.authService.updateContract(this.contractData).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.router.navigateByUrl('/contracts');
    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })
  }

}
